const ui = {
  state: {
    flash: [],
    ajax_queue: [],
    modalBibleAuth: {
      opened: false,
    },
    modalBibleOpen: {
      opened: false,
    },
    modalBibleBookOpen: {
      opened: false,
    },
    modalBibleAction: {
      opened: false,
    },
    modalBibleCopy: {
      opened: false,
    },
    modalBibleNews: {
      opened: false,
    },
    modalBibleTool: {
      opened: false,
    },
    modalBibleBuy: {
      opened: false,
    },
    tabsBibleOpen: {
      index: 0,
    },
  },
  mutations: {
    UI_TOGGLE_MODAL_BIBLE_AUTH: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleAuth.opened = !state.modalBibleAuth.opened
      } else {
        state.modalBibleAuth.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_OPEN: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleOpen.opened = !state.modalBibleOpen.opened
      } else {
        state.modalBibleOpen.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_BOOK_OPEN: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleBookOpen.opened = !state.modalBibleBookOpen.opened
      } else {
        state.modalBibleBookOpen.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_ACTION: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleAction.opened = !state.modalBibleAction.opened
      } else {
        state.modalBibleAction.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_COPY: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleCopy.opened = !state.modalBibleCopy.opened
      } else {
        state.modalBibleCopy.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_NEWS: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleNews.opened = !state.modalBibleNews.opened
      } else {
        state.modalBibleNews.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_TOOL: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleTool.opened = !state.modalBibleTool.opened
      } else {
        state.modalBibleTool.opened = opened
      }
    },
    UI_TOGGLE_MODAL_BIBLE_BUY: (state, opened) => {
      if (typeof opened === undefined) {
        state.modalBibleBuy.opened = !state.modalBibleBuy.opened
      } else {
        state.modalBibleBuy.opened = opened
      }
    },
    UI_SET_TABS_BIBLE_OPEN: (state, index) => {
      state.tabsBibleOpen.index = index
    },
    UI_PUSH_FLASH: (state, item) => {
      let flash = JSON.parse(JSON.stringify(item))
      switch (flash.variant) {
        case 'danger':
          flash.life = 3
          break
        default:
          flash.life = 3
          break
      }
      for (let i = state.flash.length - 1; i >= 0; i--) {
        if (flash.variant === state.flash[i].variant && flash.text === state.flash[i].text) {
          state.flash[i].life = 3
          return
        }
      }
      state.flash.push(flash)
    },
    UI_PLAY_FLASH: (state, tick = 1) => {
      if (!tick) {
        tick = 1
      }
      for (let i = state.flash.length - 1; i >= 0; i--) {
        state.flash[i].life -= tick
        if (state.flash[i].life <= 0) {
          state.flash.splice(i, 1)
        }
      }
    },
    UI_REQUEST: (state, iso8601) => {
      let queue = {}
      queue[iso8601] = true
      state.ajax_queue = Object.assign(queue, state.ajax_queue)
    },
    UI_RESPONSE: (state, iso8601) => {
      let queue = { ...state.ajax_queue }
      if (queue[iso8601]) {
        delete queue[iso8601]
        state.ajax_queue = { ...queue }
      }
    },
  },

  actions: {
    uiToggleModalBibleAuth: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_AUTH', opened)
    },
    uiToggleModalBibleOpen: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_OPEN', opened)
    },
    uiToggleModalBibleBookOpen: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_BOOK_OPEN', opened)
    },
    uiToggleModalBibleAction: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_ACTION', opened)
    },
    uiToggleModalBibleCopy: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_COPY', opened)
    },
    uiToggleModalBibleNews: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_NEWS', opened)
    },
    uiToggleModalBibleTool: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_TOOL', opened)
    },
    uiToggleModalBibleBuy: ({ commit }, opened) => {
      commit('UI_TOGGLE_MODAL_BIBLE_BUY', opened)
    },
    uiSetTabsBibleOpen: ({ commit }, index) => {
      commit('UI_SET_TABS_BIBLE_OPEN', index)
    },
    uiPushFlash: ({ commit }, { variant, text, }) => {
      commit('UI_PUSH_FLASH', { variant: variant, text: text, })
    },
    uiPlayFlash: ({ commit }, tick = 1) => {
      commit('UI_PLAY_FLASH', tick)
    },
    uiPushFlashFromQuery: ({ commit }, query = null) => {
      let params = new URLSearchParams(query || location.search)
      let variant = null
      let text = null
      if (text = params.get('success')) {
        variant = 'success'
      } else if (text = params.get('error')) {
        variant = 'danger'
      }
      if (variant && text) {
          commit('UI_PUSH_FLASH', { variant: variant, text: text, })
          params.delete('success')
          params.delete('error')
          history.replaceState(null, null, '?' + params.toString());
      }
    },
    uiRequest: ({ commit }, iso8601) => {
      commit('UI_REQUEST', iso8601)
    },
    uiResponse: ({ commit }, iso8601) => {
      commit('UI_RESPONSE', iso8601)
    },
  }
}

export default ui
